export const samaraArenaConfig = {
    arenaImage: '../public/tickets/img/mockup/initMockup/finalArena.svg',
    /*arenaImage: './img/mockup/initMockup/finalArena.svg',*/
    isMetallArena: false,
    sectors: [
        {
            id: 118848,
            name: 'с525',
            color: '#FF6B6D',
            coordinates: 'M197.494 149.055C178.641 153.289 161.265 162.519 147.179 175.784L108.437 138.085L108.963 136.615L153.416 122.478L173.144 84.1387L182.275 83.3093L197.494 149.055Z',
            textX: '158',
            textY: '142',
            textRotate: '60',
            textColor: 'white'
        },
        {
            id: 117899,
            name: 'с524',
            color: '#FF6B6D',
            coordinates: 'M265.057 55.8651V146.341H221.243C215.467 146.334 209.699 146.788 203.995 147.698L188.964 82.6687L216.884 80.256L249.651 50.625L265.057 55.8651Z',
            textX: '230',
            textY: '115',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 117029,
            name: 'с523',
            color: '#FF6B6D',
            coordinates: 'M329.764 48.4006V146.417H271.708V58.1645L291.699 65.0256L329.764 48.4006Z',
            textX: '300',
            textY: '115',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 115993,
            name: 'с522',
            color: '#FF6B6D',
            coordinates: 'M394.471 34.1131V146.417H336.415V45.498L343.066 42.5952L361.404 53.9425L394.171 34L394.471 34.1131Z',
            textX: '366',
            textY: '115',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 115011,
            name: 'с521',
            color: '#FF6B6D',
            coordinates: 'M459.178 37.1666V146.417H401.122V37.0535L430.357 49.7955L459.178 37.1666Z',
            textX: '430',
            textY: '115',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 113984,
            name: 'с520',
            color: '#FF6B6D',
            coordinates: 'M523.585 45.6111V146.417H465.83V34.2639L466.393 34L498.596 53.6786L517.197 42.8591L523.585 45.6111Z',
            textX: '495',
            textY: '115',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 113116,
            name: 'с519',
            color: '#FF6B6D',
            coordinates: 'M588.593 58.4661V146.416H530.273V48.5137L569.128 65.2895L588.593 58.4661Z',
            textX: '560',
            textY: '115',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 112152,
            name: 'с518',
            color: '#FF6B6D',
            coordinates: 'M671.111 82.6309L655.179 147.548C649.965 146.788 644.702 146.41 639.434 146.417H595.244V55.9404L610.8 50.4741L643.567 80.369L671.111 82.6309Z',
            textX: '627',
            textY: '115',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 111494,
            name: 'с517',
            color: '#FF6B6D',
            coordinates: 'M751.638 139.065L713.685 175.934C699.192 162.253 681.226 152.837 661.754 148.716L677.837 83.0078L687.156 83.6864L706.621 122.742L750.774 136.615L751.638 139.065Z',
            textX: '703',
            textY: '143',
            textRotate: '-55',
            textColor: 'white'
        },
        {
            id: 110901,
            name: 'd516',
            color: '#FFD300',
            coordinates: 'M796.58 204.058V220.758L745.363 232.746C741.382 213.197 732.038 195.153 718.383 180.647L754.231 145.889L765.504 176.349L796.58 204.058Z',
            textX: '756',
            textY: '200',
            textRotate: '-27',
            textColor: '#0B193B'
        },
        {
            id: 110236,
            name: 'd515',
            color: '#FFD300',
            coordinates: 'M819.614 281.49L816.57 298.756H747.504V254.197C747.511 249.228 747.172 244.265 746.49 239.344L796.58 227.619V247.26L819.614 281.49Z',
            textX: '777',
            textY: '271',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 109540,
            name: 'd514',
            color: '#FFD300',
            coordinates: 'M831 360.506L829.648 363.861H747.505V305.428H815.368L812.137 323.674L831 360.506Z',
            textX: '777',
            textY: '340',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 108833,
            name: 'd513',
            color: '#FFD300',
            coordinates: 'M815.181 399.373L826.792 428.363H747.505V370.496H826.942L815.181 399.373Z',
            textX: '777',
            textY: '403',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 108136,
            name: 'd512',
            color: '#FFD300',
            coordinates: 'M811.874 475.448L815.105 492.903H747.505V435.036H829.46L831 438.919L811.874 475.448Z',
            textX: '777',
            textY: '467',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 107467,
            name: 'd511',
            color: '#FFD300',
            coordinates: 'M796.317 550.807V571.655L746.302 559.44C747.028 554.346 747.392 549.206 747.392 544.059V499.538H816.232L819.502 517.294L796.317 550.807Z',
            textX: '777',
            textY: '531',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 106875,
            name: 'd510',
            color: '#FFD300',
            coordinates: 'M796.58 594.538L765.203 622.812L753.93 653.423L718.646 617.232C731.995 602.912 741.171 585.191 745.175 566L796.392 578.478L796.58 594.538Z',
            textX: '750',
            textY: '605',
            textRotate: '33',
            textColor: '#0B193B'
        },
        {
            id: 106198,
            name: 'a509',
            color: '#138EFF',
            coordinates: 'M751.488 660.359L751.037 661.566L706.32 676.645L687.156 714.871L678.063 715.587L662.018 649.578C681.562 645.412 699.575 635.9 714.061 622.095L751.488 660.359Z',
            textX: '698',
            textY: '657',
            textRotate: '56',
            textColor: 'white'
        },
        {
            id: 105251,
            name: 'a508',
            color: '#138EFF',
            coordinates: 'M671.299 716.002L642.44 718.339L610.5 747.97L595.808 742.956V651.839H639.434C644.792 651.852 650.143 651.461 655.442 650.67L671.299 716.002Z',
            textX: '623',
            textY: '692',
            textRotate: '90',
            textColor: 'white'
        },
        {
            id: 104389,
            name: 'a507',
            color: '#138EFF',
            coordinates: 'M589.119 651.839V740.694L568.301 733.569L554.961 739.488V651.839H589.119Z',
            textX: '571',
            textY: '692',
            textRotate: '90',
            textColor: 'white'
        },
        {
            id: 103121,
            name: 'a503',
            color: '#138EFF',
            coordinates: 'M300.304 651.839V737.037L291.436 733.041L271.445 740.053V651.839H300.304Z',
            textX: '290',
            textY: '692',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 102175,
            name: 'a502',
            color: '#138EFF',
            coordinates: 'M264.756 651.839V742.316L248.937 747.895L217.56 718L189.377 716.078L204.897 650.52C210.305 651.355 215.77 651.771 221.243 651.764L264.756 651.839Z',
            textX: '237',
            textY: '692',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 101506,
            name: 'a501',
            color: '#138EFF',
            coordinates: 'M198.358 649.389L182.651 715.663L173.144 715.022L153.417 675.966L108.963 661.302L147.066 622.435C161.408 635.931 179.138 645.261 198.358 649.427',
            textX: '166',
            textY: '661',
            textRotate: '-67',
            textColor: 'white'
        },
        {
            id: 123553,
            name: 'b532',
            color: '#32C454',
            coordinates: 'M142.369 617.684L106.483 654.29L95.2104 622.51L63.5332 594.538L63.7587 577.95L115.427 565.208C119.418 584.895 128.815 603.071 142.557 617.684',
            textX: '107',
            textY: '606',
            textRotate: '-31',
            textColor: 'white'
        },
        {
            id: 122886,
            name: 'b531',
            color: '#32C454',
            coordinates: 'M63.721 571.089L63.9841 550.468L40.6489 516.539L44.4066 497.954H113.172V544.059C113.174 548.939 113.501 553.813 114.149 558.649L63.721 571.089Z',
            textX: '85',
            textY: '533',
            textRotate: '-5',
            textColor: 'white'
        },
        {
            id: 122188,
            name: 'b530',
            color: '#32C454',
            coordinates: 'M113.172 434.47V491.244H45.6089L48.7278 475.448L29 438.089L30.5782 434.47H113.172Z',
            textX: '80',
            textY: '468',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 121479,
            name: 'b529',
            color: '#32C454',
            coordinates: 'M113.172 371.061V427.835H33.5093L46.2102 398.732L33.9978 371.061H113.172Z',
            textX: '80',
            textY: '402',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 120781,
            name: 'b528',
            color: '#32C454',
            coordinates: 'M113.172 305.957V364.389H31.0667L29 359.677L48.7278 323.411L45.4962 305.957H113.172Z',
            textX: '80',
            textY: '340',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 120109,
            name: 'b527',
            color: '#32C454',
            coordinates: 'M114.186 239.381C113.507 244.29 113.168 249.24 113.172 254.197V299.435H44.256L40.9492 281.603L64.2844 247.675V227.242L114.186 239.381Z',
            textX: '80',
            textY: '271',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 119510,
            name: 'b526',
            color: '#32C454',
            coordinates: 'M142.482 180.459C128.758 195.03 119.384 213.172 115.427 232.822L64.2847 220.381V203.643L94.8346 175.407L105.92 144.984L142.482 180.459Z',
            textX: '104',
            textY: '200',
            textRotate: '30',
            textColor: 'white'
        },
        {
            id: 124151,
            name: 'vip',
            color: '#138EFF',
            coordinates: 'M484.693 608.788H377.186V624.094H484.693V608.788Z',
            textX: '432',
            textY: '619',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 93111,
            name: 'c125',
            color: '#FF6B6D',
            coordinates: 'M235.672 260.944C232.937 262.674 230.687 265.074 229.134 267.919L172.318 254.196C175.922 242.346 182.343 231.552 191.03 222.745C199.717 213.938 210.408 207.382 222.182 203.643L235.672 260.944Z',
            textX: '207',
            textY: '245',
            textRotate: '45',
            textColor: 'white'
        },
        {
            id: 92618,
            name: 'c124',
            color: '#FF6B6D',
            coordinates: 'M277.007 199.873V257.929H245.63C244.189 257.938 242.753 258.103 241.346 258.419L228.194 201.871C233.923 200.532 239.786 199.862 245.668 199.873H277.007Z',
            textX: '256',
            textY: '232',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 91918,
            name: 'c123',
            color: '#FF6B6D',
            coordinates: 'M337.279 199.949H283.131V258.004H337.279V199.949Z',
            textX: '310',
            textY: '232',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 91218,
            name: 'c122',
            color: '#FF6B6D',
            coordinates: 'M397.665 199.949H343.517V258.004H397.665V199.949Z',
            textX: '370',
            textY: '232',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 90530,
            name: 'c121',
            color: '#FF6B6D',
            coordinates: 'M458.013 199.949H403.865V258.004H458.013V199.949Z',
            textX: '430',
            textY: '232',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 89830,
            name: 'c120',
            color: '#FF6B6D',
            coordinates: 'M518.136 199.949H464.251V258.004H518.136V199.949Z',
            textX: '490',
            textY: '232',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 89130,
            name: 'c119',
            color: '#FF6B6D',
            coordinates: 'M578.748 199.949H524.336V258.004H578.748V199.949Z',
            textX: '551',
            textY: '232',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 88634,
            name: 'c118',
            color: '#FF6B6D',
            coordinates: 'M632.219 201.607L618.278 258.155C617.514 258.116 616.749 258.116 615.986 258.155H585.135V199.873H616.474C621.828 199.866 627.168 200.422 632.407 201.532',
            textX: '604',
            textY: '232',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 88241,
            name: 'c117',
            color: '#FF6B6D',
            coordinates: 'M689.561 253.858L632.182 267.203C630.315 264.043 627.556 261.511 624.253 259.927L638.231 203.115C650.293 206.675 661.29 213.17 670.245 222.022C679.201 230.875 685.836 241.811 689.561 253.858Z',
            textX: '653',
            textY: '245',
            textRotate: '-42',
            textColor: 'white'
        },
        {
            id: 87715,
            name: 'd116',
            color: '#FFD300',
            coordinates: 'M692.831 275.873V306.861H634.775V276.702C634.795 275.435 634.669 274.17 634.399 272.933L691.102 259.813C692.25 265.089 692.829 270.473 692.831 275.873Z',
            textX: '663',
            textY: '290',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 87015,
            name: 'd115',
            color: '#FFD300',
            coordinates: 'M692.83 313.006H634.774V367.254H692.83V313.006Z',
            textX: '663',
            textY: '344',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 86313,
            name: 'd114',
            color: '#FFD300',
            coordinates: 'M692.83 373.399H634.774V427.119H692.83V373.399Z',
            textX: '663',
            textY: '404',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 85613,
            name: 'd113',
            color: '#FFD300',
            coordinates: 'M692.83 433.301H634.774V487.022H692.83V433.301Z',
            textX: '663',
            textY: '464',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 85085,
            name: 'd112',
            color: '#FFD300',
            coordinates: 'M692.83 493.167V524.079C692.837 529.544 692.245 534.992 691.064 540.327L634.699 526.605C634.85 525.683 634.926 524.75 634.925 523.815V493.167H692.83Z',
            textX: '663',
            textY: '514',
            textRotate: '0',
            textColor: '#0B193B'
        },
        {
            id: 84709,
            name: 'a111',
            color: '#138EFF',
            coordinates: 'M689.523 546.284C685.785 558.232 679.186 569.08 670.304 577.88C661.421 586.679 650.526 593.162 638.569 596.762L624.779 540.214C628.112 538.467 630.837 535.746 632.595 532.411L689.523 546.284Z',
            textX: '651',
            textY: '562',
            textRotate: '41',
            textColor: 'white'
        },
        {
            id: 84204,
            name: 'a110',
            color: '#138EFF',
            coordinates: 'M632.52 598.307C627.184 599.45 621.742 600.019 616.287 600.004H585.474V542.438H615.986C616.941 542.433 617.894 542.37 618.842 542.25L632.52 598.307Z',
            textX: '605',
            textY: '575',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 83504,
            name: 'a109',
            color: '#138EFF',
            coordinates: 'M579.274 542.438H524.6V600.004H579.274V542.438Z',
            textX: '551',
            textY: '575',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 83132,
            name: 'a108',
            color: '#138EFF',
            coordinates: 'M518.399 542.438H490.931V600.004H518.399V542.438Z',
            textX: '510',
            textY: '573',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 82904,
            name: 'a107',
            color: '#138EFF',
            coordinates: 'M484.693 542.438H458.088V600.004H484.693V542.438Z',
            textX: '475',
            textY: '573',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 82419,
            name: 'a106',
            color: '#138EFF',
            coordinates: 'M452.941 542.438H412.17V600.004H452.941V542.438Z',
            textX: '438',
            textY: '573',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 82191,
            name: 'a105',
            color: '#138EFF',
            coordinates: 'M406.984 542.438H377.186V600.004H406.984V542.438Z',
            textX: '397',
            textY: '573',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 81819,
            name: 'a104',
            color: '#138EFF',
            coordinates: 'M370.986 542.438H344.043V600.004H370.986V542.438Z',
            textX: '362',
            textY: '573',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 81119,
            name: 'a103',
            color: '#138EFF',
            coordinates: 'M337.843 542.438H282.906V600.004H337.843V542.438Z',
            textX: '311',
            textY: '575',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 80593,
            name: 'a102',
            color: '#138EFF',
            coordinates: 'M276.668 542.438V600.004H245.668C240.121 600.011 234.59 599.417 229.171 598.232L242.511 542.174C243.541 542.357 244.585 542.446 245.63 542.438H276.668Z',
            textX: '256',
            textY: '575',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 80200,
            name: 'a101',
            color: '#138EFF',
            coordinates: 'M236.612 540.177L223.159 596.725C211.122 593.067 200.173 586.478 191.289 577.546C182.405 568.613 175.862 557.615 172.243 545.53L228.608 531.695C230.307 535.315 233.11 538.299 236.612 540.215',
            textX: '213',
            textY: '560',
            textRotate: '-45',
            textColor: 'white'
        },
        {
            id: 96133,
            name: 'b130',
            color: '#32C454',
            coordinates: 'M226.954 525.738L170.589 539.536C169.527 534.453 168.998 529.273 169.011 524.079V491.659H226.842V523.815C226.804 524.456 226.804 525.098 226.842 525.738',
            textX: '198',
            textY: '514',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 95433,
            name: 'b129',
            color: '#32C454',
            coordinates: 'M226.841 432.774H169.161V485.476H226.841V432.774Z',
            textX: '198',
            textY: '464',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 94731,
            name: 'b128',
            color: '#32C454',
            coordinates: 'M226.841 373.927H169.161V426.629H226.841V373.927Z',
            textX: '198',
            textY: '404',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 94031,
            name: 'b127',
            color: '#32C454',
            coordinates: 'M226.841 313.534H169.161V367.744H226.841V313.534Z',
            textX: '198',
            textY: '344',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 93504,
            name: 'b126',
            color: '#32C454',
            coordinates: 'M227.067 273.8C226.916 274.747 226.84 275.705 226.841 276.665V307.351H169.161V275.873C169.159 270.602 169.713 265.345 170.815 260.191L227.067 273.8Z',
            textX: '198',
            textY: '290',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 101413,
            name: 'b424',
            color: '#32C454',
            coordinates: 'M162.087 624.852C173.943 634.194 187.79 640.745 202.605 643.96C204.747 644.45 206.889 644.865 209.106 645.167C209.461 645.222 209.817 645.274 210.173 645.325C210.667 645.395 211.162 645.46 211.659 645.522C212.281 645.598 212.907 645.669 213.54 645.732L216.884 628.127C216.023 628.127 215.161 627.909 214.287 627.687L214.283 627.686L214.276 627.685C213.896 627.588 213.513 627.49 213.127 627.411C210.985 626.958 208.843 626.431 206.738 625.79C195.273 622.442 184.602 616.87 175.319 609.417L162.087 624.852Z',
            textX: '189',
            textY: '633',
            textRotate: '26',
            textColor: 'white'
        },
        {
            id: 101335,
            name: 'b423',
            color: '#32C454',
            coordinates: 'M150.298 613.952C138.659 601.349 130.422 586.006 126.327 569.379L144.812 564.526C148.797 577.369 155.521 589.209 164.54 599.212C166.005 600.871 167.546 602.454 169.162 604C169.691 604.51 170.226 605.013 170.767 605.509L157.488 620.998C156.632 620.236 155.789 619.458 154.958 618.665C153.379 617.157 151.801 615.573 150.298 613.952Z',
            textX: '144',
            textY: '594',
            textRotate: '60',
            textColor: 'white'
        },
        {
            id: 101207,
            name: 'b422',
            color: '#32C454',
            coordinates: 'M123.393 505.004V545.04C123.391 549.375 123.654 553.706 124.182 558.008C124.433 559.86 124.734 561.685 125.067 563.506L143.229 558.738C142.831 557.025 142.475 555.273 142.144 553.522C141.191 548.083 140.713 542.57 140.716 537.048V505.004H123.393Z',
            textX: '136',
            textY: '534',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 101089,
            name: 'b421',
            color: '#32C454',
            coordinates: 'M123.393 440V499.877H140.753V440H123.393Z',
            textX: '136',
            textY: '470',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 100986,
            name: 'b420',
            color: '#32C454',
            coordinates: 'M123.393 434H140.753V373.625H123.393V434Z',
            textX: '136',
            textY: '405',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 100835,
            name: 'b419',
            color: '#32C454',
            coordinates: 'M123.393 254.875C123.395 252.227 123.499 249.58 123.705 246.942L141.457 251.445C140.99 255.245 140.755 259.073 140.753 262.905V368.46H123.393V254.875Z',
            textX: '136',
            textY: '311',
            textRotate: '-90',
            textColor: 'white'
        },
        {
            id: 100689,
            name: 'b418',
            color: '#32C454',
            coordinates: 'M211.773 154.635L208.016 155.125C205.836 155.464 203.694 155.879 201.553 156.369C184.188 160.311 168.183 168.821 155.183 181.024C153.605 182.532 152.026 184.077 150.523 185.736C137.699 199.501 128.978 216.597 125.347 235.083C125.177 235.892 125.019 236.706 124.872 237.525C124.672 238.645 124.496 239.775 124.348 240.915L142.377 245.488C142.734 243.529 143.179 241.575 143.685 239.683C147.455 224.919 154.829 211.328 165.141 200.137C166.644 198.478 168.185 196.933 169.8 195.425C180.042 185.725 192.392 178.549 205.874 174.464C207.979 173.823 210.083 173.258 212.262 172.768L215.531 172.089L211.773 154.635Z',
            textX: '163',
            textY: '194',
            textRotate: '-45',
            textColor: 'white'
        },
        {
            id: 100535,
            name: 'c417',
            color: '#FF6B6D',
            coordinates: 'M223.723 153.73H301V170.544H232.403C228.496 170.546 224.593 170.798 220.717 171.298L216.959 153.957C219.176 153.73 221.469 153.73 223.723 153.73Z',
            textX: '258',
            textY: '166',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 100381,
            name: 'c416',
            color: '#FF6B6D',
            coordinates: 'M370.272 170.544H307V153.73H370.272V170.544Z',
            textX: '338',
            textY: '166',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 100291,
            name: 'c415',
            color: '#FF6B6D',
            coordinates: 'M477.103 153.73H375.646V170.544H477.291L477.103 153.73Z',
            textX: '424',
            textY: '166',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 100140,
            name: 'c414',
            color: '#FF6B6D',
            coordinates: 'M553 153.73H482.289V170.544H553V153.73Z',
            textX: '515',
            textY: '166',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 99986,
            name: 'c413',
            color: '#FF6B6D',
            coordinates: 'M559 170.544H628.838C632.847 170.54 636.851 170.805 640.825 171.336L645.372 154.032C642.779 153.844 640.148 153.73 637.518 153.73H559V170.544Z',
            textX: '598',
            textY: '166',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 99833,
            name: 'd412',
            color: '#FFD300',
            coordinates: 'M735.894 235.008C736.345 237.195 736.683 239.381 736.983 241.605V241.492C737.012 241.714 737.04 241.936 737.067 242.157L718.971 246.112L718.947 245.978C718.533 243.792 718.045 241.605 717.481 239.494C713.697 224.948 706.421 211.552 696.288 200.476C694.785 198.818 693.244 197.234 691.666 195.726C680.923 185.523 667.875 178.085 653.638 174.05C651.534 173.447 649.392 172.919 647.25 172.504L646.01 172.24L650.557 154.71H651.534C652.776 154.882 654.019 155.079 655.254 155.3C656.186 155.466 657.114 155.647 658.035 155.841C676.145 159.678 692.836 168.488 706.246 181.288C707.861 182.796 709.402 184.341 710.868 186C723.583 199.688 732.249 216.658 735.894 235.008Z',
            textX: '698',
            textY: '194',
            textRotate: '45',
            textColor: '#0B193B'
        },
        {
            id: 99678,
            name: 'd411',
            color: '#FFD300',
            coordinates: 'M719.856 252.061C720.279 255.696 720.49 259.355 720.487 263.018V307.615H737.848V254.837C737.847 252.615 737.774 250.393 737.631 248.176L719.856 252.061Z',
            textX: '733',
            textY: '279',
            textRotate: '-90',
            textColor: '#0B193B'
        },
        {
            id: 99570,
            name: 'd410',
            color: '#FFD300',
            coordinates: 'M737.763 367.29H720.402V313.258H737.763V367.29Z',
            textX: '733',
            textY: '340',
            textRotate: '-90',
            textColor: '#0B193B'
        },
        {
            id: 99477,
            name: 'd409',
            color: '#FFD300',
            coordinates: 'M720.402 432.29V373.29H737.763V432.29H720.402Z',
            textX: '733',
            textY: '402',
            textRotate: '-90',
            textColor: '#0B193B'
        },
        {
            id: 99375,
            name: 'd408',
            color: '#FFD300',
            coordinates: 'M720.402 438.29V496.435H737.763V438.29H720.402Z',
            textX: '733',
            textY: '468',
            textRotate: '-90',
            textColor: '#0B193B'
        },
        {
            id: 98852,
            name: 'b366',
            color: '#32C454',
            coordinates: 'M221.506 604.565C209.468 600.691 198.441 594.174 189.227 585.49C187.762 584.057 186.334 582.625 184.981 581.154C178.98 574.6 174.036 567.147 170.326 559.063L153.529 566.113C157.799 576.691 163.992 586.381 171.792 594.688C173.182 596.158 174.61 597.629 176.113 598.986C187.96 610.086 202.494 617.883 218.274 621.605L221.506 604.565Z',
            textX: '183',
            textY: '596',
            textRotate: '41',
            textColor: 'white'
        },
        {
            id: 98921,
            name: 'a401',
            color: '#0085FF',
            coordinates: 'M261 629.635H232.328C228.9 629.624 225.476 629.423 222.07 629.032L218.726 646.109H261V629.635Z',
            textX: '240',
            textY: '641',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 99020,
            name: 'a402',
            color: '#0085FF',
            coordinates: 'M267 629.635H307V646.109H267V629.635Z',
            textX: '287',
            textY: '641',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 99039,
            name: 'a403',
            color: '#0085FF',
            coordinates: 'M358 629.635H313V646.109H358V629.635Z',
            textX: '335',
            textY: '641',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 99106,
            name: 'a404',
            color: '#0085FF',
            coordinates: 'M364 646.109H405.52V629.635H364V646.109Z',
            textX: '385',
            textY: '641',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 99191,
            name: 'a405',
            color: '#0085FF',
            coordinates: 'M460 629H411V646H460V629Z',
            textX: '435',
            textY: '641',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 99223,
            name: 'a406',
            color: '#0085FF',
            coordinates: 'M467 629H522V646H467V629Z',
            textX: '495',
            textY: '641',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 99308,
            name: 'a407',
            color: '#0085FF',
            coordinates: 'M579 629H529V646H579V629Z',
            textX: '552',
            textY: '641',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 98783,
            name: 'b365',
            color: '#32C454',
            coordinates: 'M168.372 554.313C167.276 551.413 166.335 548.455 165.554 545.454C165.066 543.531 164.615 541.684 164.276 539.535C163.36 534.562 162.907 529.514 162.924 524.456V504.74H146.841V531.732C146.844 535.677 147.095 539.618 147.592 543.531C147.893 545.529 148.194 547.527 148.607 549.525C149.394 553.484 150.436 557.388 151.726 561.212L168.372 554.313Z',
            textX: '151',
            textY: '534',
            textRotate: '90',
            textColor: 'white'
        },
        {
            id: 98698,
            name: 'b364',
            color: '#32C454',
            coordinates: 'M162.924 499.726V455.845H146.841V499.877L162.924 499.726Z',
            textX: '151',
            textY: '479',
            textRotate: '90',
            textColor: 'white'
        },
        {
            id: 98613,
            name: 'b363',
            color: '#32C454',
            coordinates: 'M162.924 450.718V413.246H146.841V450.718H162.924Z',
            textX: '151',
            textY: '433',
            textRotate: '90',
            textColor: 'white'
        },
        {
            id: 98536,
            name: 'b362',
            color: '#32C454',
            coordinates: 'M162.924 408.119V373.625H146.841V408.119H162.924Z',
            textX: '151',
            textY: '392',
            textRotate: '90',
            textColor: 'white'
        },
        {
            id: 98451,
            name: 'b361',
            color: '#32C454',
            coordinates: 'M162.924 368.46V312.968H146.841V368.46H162.924Z',
            textX: '151',
            textY: '341',
            textRotate: '90',
            textColor: 'white'
        },
        {
            id: 98368,
            name: 'b360',
            color: '#32C454',
            coordinates: 'M162.924 307.615V275.269C162.905 270.212 163.358 265.163 164.276 260.19L164.615 258.418L147.818 254.648L147.592 256.232C147.063 260.218 146.8 264.236 146.803 268.258V307.615H162.924Z',
            textX: '151',
            textY: '283',
            textRotate: '90',
            textColor: 'white'
        },
        {
            id: 98301,
            name: 'b359',
            color: '#32C454',
            coordinates: 'M165.855 253.254C169.081 241.397 174.881 230.403 182.839 221.059L168.41 209.071C158.631 220.644 151.889 234.483 148.795 249.333L165.855 253.254Z',
            textX: '168',
            textY: '235',
            textRotate: '-63',
            textColor: 'white'
        },
        {
            id: 98240,
            name: 'b358',
            color: '#32C454',
            coordinates: 'M186.296 217.252C187.461 216.083 188.588 214.914 189.791 213.821C198.669 205.615 209.185 199.395 220.641 195.575L216.884 178.686C201.685 182.505 187.689 190.103 176.188 200.778C174.723 202.172 173.257 203.605 171.904 205.075L186.296 217.252Z',
            textX: '198',
            textY: '201',
            textRotate: '-33',
            textColor: 'white'
        },
        {
            id: 97632,
            name: 'd329',
            color: '#FFD300',
            coordinates: 'M640.224 195.01C652.353 198.768 663.486 205.21 672.803 213.859C673.629 214.613 674.418 215.405 675.208 216.197L689.712 204.133C688.585 203.002 687.458 201.871 686.293 200.816C674.57 189.768 660.182 181.972 644.545 178.197L640.224 195.01Z',
            textX: '663',
            textY: '199',
            textRotate: '33',
            textColor: '#0B193B'
        },
        {
            id: 97563,
            name: 'd328',
            color: '#FFD300',
            coordinates: 'M678.702 220.08C686.926 229.475 692.937 240.608 696.288 252.651L713.385 248.881C710.155 233.76 703.147 219.711 693.019 208.054L678.702 220.08Z',
            textX: '694',
            textY: '231',
            textRotate: '64',
            textColor: '#0B193B'
        },
        {
            id: 97479,
            name: 'd327',
            color: '#FFD300',
            coordinates: 'M697.491 257.778C697.491 258.419 697.754 259.098 697.904 259.739C698.857 264.848 699.335 270.035 699.332 275.233V307.616H715.377V267.995C715.381 263.935 715.118 259.88 714.588 255.856C714.588 255.215 714.588 254.574 714.325 253.971L697.491 257.778Z',
            textX: '711',
            textY: '281',
            textRotate: '-90',
            textColor: '#0B193B'
        },
        {
            id: 97395,
            name: 'd326',
            color: '#FFD300',
            coordinates: 'M699.332 312.78V368.461H715.377V312.969L699.332 312.78Z',
            textX: '711',
            textY: '341',
            textRotate: '-90',
            textColor: '#0B193B'
        },
        {
            id: 97311,
            name: 'd325',
            color: '#FFD300',
            coordinates: 'M699.332 373.625V408.119H715.377V373.625H699.332Z',
            textX: '711',
            textY: '392',
            textRotate: '-90',
            textColor: '#0B193B'
        },
        {
            id: 97226,
            name: 'd324',
            color: '#FFD300',
            coordinates: 'M699.332 413.246V450.719H715.377V413.246H699.332Z',
            textX: '711',
            textY: '431',
            textRotate: '-90',
            textColor: '#0B193B'
        },
        {
            id: 97143,
            name: 'd323',
            color: '#FFD300',
            coordinates: 'M699.332 455.846V499.877H715.377V455.846H699.332Z',
            textX: '711',
            textY: '477',
            textRotate: '-90',
            textColor: '#0B193B'
        },
        {
            id: 97074,
            name: 'd322',
            color: '#FFD300',
            coordinates: 'M699.332 524.721C699.347 530.023 698.844 535.313 697.829 540.516C697.453 542.502 697.002 544.462 696.476 546.397C695.687 549.38 694.721 552.314 693.583 555.181L710.267 562.193C711.598 558.386 712.678 554.494 713.498 550.544C713.912 548.546 714.25 546.586 714.513 544.55C715.105 540.392 715.394 536.197 715.377 531.996V505.004H699.332V524.721Z',
            textX: '710',
            textY: '535',
            textRotate: '-85',
            textColor: '#0B193B'
        },
        {
            id: 97048,
            name: 'd321',
            color: '#FFD300',
            coordinates: 'M691.591 559.893C688.043 567.536 683.355 574.591 677.688 580.816C676.335 582.324 674.944 583.794 673.479 585.189C663.819 594.452 652.116 601.298 639.322 605.169L643.493 621.719C659.659 618.015 674.541 610.035 686.593 598.61C688.096 597.215 689.487 595.782 690.877 594.274C698.291 586.304 704.233 577.075 708.425 567.018L691.591 559.893Z',
            textX: '680',
            textY: '596',
            textRotate: '-46',
            textColor: '#0B193B'
        },
        /*{
            id: 'Skybox S330-S357',
            name: 'Skybox S330-S357',
            color: '#FF6B6D',
            coordinates: 'M225.526 194.068L229.284 193.2C235.369 191.862 241.58 191.192 247.809 191.202H614.784C620.473 191.194 626.15 191.75 631.731 192.861L635.488 193.653L639.321 177.254L635.564 176.613C631.266 176.038 626.935 175.748 622.6 175.746H239.693C234.875 175.747 230.064 176.112 225.301 176.839L221.994 177.405L225.526 194.068Z',
            textX: '425',
            textY: '187',
            textRotate: '0',
            textColor: 'white'
        },*/
       {
            id: 98155,
            name: 's354',
            color: '#ff6b6d',
            coordinates: 'M331 191.202V175.746H274V191.202H331Z',
            textX: '302.5',
            textY: '187',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 'Skybox S330-S357',
            name: 'Skybox S330-S357',
            color: '#FF6B6D',
            coordinates: 'M614.784 191.202C620.473 191.194 626.15 191.75 631.731 192.861L635.488 193.653L639.321 177.254L635.564 176.613C631.266 176.038 626.935 175.748 622.6 175.746H333.617V191.202H614.784Z',
            textX: '425',
            textY: '187',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 'Skybox S330 - S357',
            name: 'Skybox S330-S357',
            color: '#FF6B6D',
            coordinates: 'M271.377 175.746V191.202H247.809C241.58 191.192 235.369 191.862 229.284 193.2L225.526 194.068L221.994 177.405L225.301 176.839C230.064 176.112 234.875 175.747 239.693 175.746H271.377Z',
            textX: '425',
            textY: '187',
            textRotate: '0',
            textColor: '#FF6B6D'
        },
        {
            id: 'Skybox S311-S320',
            name: 'Skybox S330-S320',
            color: '#0085FF',
            coordinates: 'M491 624.093V608.788H614.597C620.376 608.789 626.142 608.208 631.807 607.054L634.324 606.488L638.57 622.736L635.902 623.151C631.535 623.788 627.126 624.103 622.713 624.093H491Z',
            textX: '560',
            textY: '619',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 'Skybox S301-S310',
            name: 'Skybox S301-S310',
            color: '#0085FF',
            coordinates: 'M371 608.788H247.622C241.7 608.79 235.793 608.171 229.999 606.941C228.796 606.714 227.631 606.45 226.466 606.149L223.272 622.661L226.166 623.113C230.646 623.765 235.167 624.093 239.693 624.093H371V608.788Z',
            textX: '297',
            textY: '619',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 'press',
            name: 'Пресса',
            coordinates: 'M360.641 732.174V742.994L342.489 755.428L307.493 739.692V652.339H547.81V742.141L517.8 755.435L499.66 744.111V732.174V731.674H499.16H361.141H360.641V732.174Z',
            textX: '428',
            textY: '695',
            textRotate: '0',
            textColor: 'white',
            isStatic: 1
        },
    ]
}

export const metallurgArena = {
    arenaImage: '../public/tickets/img/mockup/initMockup/metallurg_background.svg',
    /*arenaImage: './img/mockup/initMockup/metallurg_background.svg',*/
    isMetallArena: true,
    sectors: [
        {

            id: 1001,
            name: '1',
            color: '#FF6B6D',
            coordinates: 'M176 118H234V208H176V118Z',
            textX: '206',
            textY: '169',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 2092,
            name: '2',
            color: '#FF6B6D',
            coordinates: 'M241 118H299V208H241V118Z',
            textX: '271',
            textY: '169',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 3714,
            name: '3',
            color: '#FF6B6D',
            coordinates: 'M306 139H364V208H306V139Z',
            textX: '336',
            textY: '169',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 5175,
            name: '4',
            color: '#FF6B6D',
            coordinates: 'M370 208L370 138H492V208H461V176H403V208H370Z',
            textX: '431',
            textY: '164',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 7010,
            name: '5',
            color: '#FF6B6D',
            coordinates: 'M499 139H557V208H499V139Z',
            textX: '529',
            textY: '169',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 8471,
            name: '6',
            color: '#FF6B6D',
            coordinates: 'M564 118H622V208H564V118Z',
            textX: '594',
            textY: '169',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 10058,
            name: '7',
            color: '#FF6B6D',
            coordinates: 'M629 118H687V208H629V118Z',
            textX: '657',
            textY: '169',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 12298,
            name: '8',
            color: '#FFD300',
            coordinates: 'M707 294L707 231L797 231L797 294L707 294Z',
            textX: '752',
            textY: '268',
            textRotate: '0',
            textColor: '#0b193b'
        },
        {
            id: 13817,
            name: '9',
            color: '#FFD300',
            coordinates: 'M707 363L707 300L797 300L797 363L707 363Z',
            textX: '752',
            textY: '338',
            textRotate: '0',
            textColor: '#0b193b'
        },
        {
            id: 15780,
            name: '10',
            color: '#FFD300',
            coordinates: 'M707 432L707 369L797 369L797 432L707 432Z',
            textX: '752',
            textY: '407',
            textRotate: '0',
            textColor: '#0b193b'
        },
        {
            id: 17886,
            name: '11',
            color: '#FFD300',
            coordinates: 'M707 501L707 438L797 438L797 501L707 501Z',
            textX: '752',
            textY: '475',
            textRotate: '0',
            textColor: '#0b193b'
        },
        {
            id: 19846,
            name: '12',
            color: '#FFD300',
            coordinates: 'M707 570L707 508L797 508L797 570L707 570Z',
            textX: '752',
            textY: '544',
            textRotate: '0',
            textColor: '#0b193b'
        },
        {
            id: 21370,
            name: '13',
            color: '#138EFF',
            coordinates: 'M613.824 590.177H680.075V685H613.824V590.177Z',
            textX: '647',
            textY: '642',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 23386,
            name: '14',
            color: '#138EFF',
            coordinates: 'M540.812 590.177H607.063V685H540.812V590.177Z',
            textX: '576',
            textY: '640',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 25343,
            name: '15',
            color: '#138EFF',
            coordinates: 'M467.801 590.177H534.052V685H467.801V590.177Z',
            textX: '501',
            textY: '640',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 27124,
            name: '16',
            color: '#138EFF',
            coordinates: 'M394.79 590.177H461.041V685H394.79V590.177Z',
            textX: '429',
            textY: '640',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 29384,
            name: '17',
            color: '#138EFF',
            coordinates: 'M321.779 590.177H388.03V685H321.779V590.177Z',
            textX: '356',
            textY: '640',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 31101,
            name: '18',
            color: '#138EFF',
            coordinates: 'M248.768 590.177H315.019V685H248.768V590.177Z',
            textX: '283',
            textY: '640',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 33012,
            name: '19',
            color: '#138EFF',
            coordinates: 'M175.756 590.177H242.007V685H175.756V590.177Z',
            textX: '209',
            textY: '640',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 34032,
            name: 'VIP-A',
            color: '#FF6B6D',
            coordinates: 'M404 193H460V208H404V193Z',
            textX: '432',
            textY: '204',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 34034,
            name: 'VIP-B',
            color: '#FF6B6D',
            coordinates: 'M404 177H460V192H404V177Z',
            textX: '432',
            textY: '188',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 34439,
            name: 'VIP-C1',
            color: '#FF6B6D',
            coordinates: 'M306 118H364V138H306V118Z',
            textX: '334',
            textY: '132',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 34449,
            name: 'VIP-C2',
            color: '#FF6B6D',
            coordinates: 'M370 118H410V137H370V118Z',
            textX: '391',
            textY: '132',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 34459,
            name: 'VIP-C3',
            color: '#FF6B6D',
            coordinates: 'M452 118H492V137H452V118Z',
            textX: '473',
            textY: '132',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 34469,
            name: 'VIP-C4',
            color: '#FF6B6D',
            coordinates: 'M498.899 117.773H557.038V138.092H498.899V117.773Z',
            textX: '527',
            textY: '132',
            textRotate: '0',
            textColor: 'white'
        },
        {
            id: 34497,
            name: 'VIP-D',
            color: '#FF6B6D',
            coordinates: 'M411 118H451V137H411V118Z',
            textX: '431',
            textY: '132',
            textRotate: '0',
            textColor: 'white'
        }
    ]
}